const InfoColumn: React.FC = () => {
    return (
        <div className="info-column">
        <h2>Adresă</h2>
        <p>
          <strong className="contact-data-field">Ne puteți găsi la următoarea adresă: </strong>
          <br/>
        B-dul Mărășești 17, Bloc Z5, Sc. A, Etaj 1, Apt. 4,
          915400, Oltenița, Călărași
        </p>
        <p>
        </p>
      </div>
    );
}

export default InfoColumn;